<template>
  <section class="faq mt-5">
    <header class="bb-1 mb-4 pb-1">
      <h4 class="font-size-h3 font-marat c-gray">Najczęściej zadawane pytania</h4>
    </header>
    <ul class="faq">
      <li v-for="(item, index) in faqList" :key="'faqItem-' + index" >
        <Collapse :selected="false">
          <div slot="collapse-header">
            <p class="font-size-h5 arrow">{{ item.question }}</p>
          </div>
          <div slot="collapse-body" v-html="item.answer"></div>
        </Collapse>
      </li>
    </ul>

  </section>
</template>

<script>
  import Collapse from './../Collapse';

  export default {
    name: "SubscriptionFAQ",
    components: { Collapse },
    data() {
      return {
        faqList: this.$appInfo.init.faq_items
      }
    }
  }
</script>

<style lang="scss">
  .faq {
    max-width: 640px;
    a {
      color: var(--color-pink);
      text-decoration: underline;
    }
  }
</style>
